import * as PopoverPrimitive from "@radix-ui/react-popover";
import React from "react";

import { cn } from "../cn";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

export function PopoverContent({ className, align = "center", sideOffset = 4, ...props }: React.ComponentProps<typeof PopoverPrimitive.Content>) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        // Portalled content must establish the token scope outside RedesignRoot.
        data-redesign-v1
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "tw-z-50 tw-w-72 tw-rounded-md tw-border tw-border-solid tw-border-border tw-bg-popover tw-p-4 tw-text-popover-foreground tw-shadow-md tw-outline-none",
          "data-[state=open]:tw-animate-in data-[state=open]:tw-fade-in-0 data-[state=open]:tw-zoom-in-95",
          "data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=closed]:tw-zoom-out-95",
          "data-[side=bottom]:tw-slide-in-from-top-2 data-[side=top]:tw-slide-in-from-bottom-2",
          "data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2",
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}
